module.exports = __webpack_public_path__ + "img/aliyun-black.b576ca7f.svg";